import {Dialog, DialogBody, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle} from '../ui/dialog'
import {XMarkIcon} from '@heroicons/react/16/solid'
import {Button} from '../ui/button'
import React from 'react'
import useAppStore from '@/store/useAppStore'
import useOpenModalWindow from '../../hooks/useOpenModalWndow'
import useArchiveCategory from '@/services/api/transaction-category/useArchiveCategory'
import {useForm} from 'react-hook-form'

export default function ArchiveCategory() {
    const {handleSubmit} = useForm({})
    const modalWindowState = useAppStore((state) => state.modalWindowState)
    const archivedEntity = useAppStore((state) => state.archivedEntity)
    const {action: archiveCategory} = useArchiveCategory(archivedEntity?.id)
    const {closeModal} = useOpenModalWindow()


    const onSubmit = (data) => {
        archiveCategory(data)
        closeModal()
    }

return (
    <form>
        <Dialog open={modalWindowState === 'opened'}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Archive {archivedEntity.direction === 1 ? 'Income' : 'Expense'} Category</DialogTitle>
                    <DialogClose>
                        <XMarkIcon onClick={() => closeModal()} />
                    </DialogClose>
                </DialogHeader>

                <DialogBody>
                    <p>
                        Archiving this {archivedEntity.direction === 1 ? 'Income' : 'Expense'} category will delete all scheduled transactions associated with it. Are you sure you want to proceed?
                    </p>
                </DialogBody>

                <DialogFooter>
                    <DialogClose asChild>
                        <Button
                            onClick={handleSubmit(onSubmit)}
                            type="button"
                            variant="destructive">
                            Archive
                        </Button>
                    </DialogClose>

                    <Button
                        type="button"
                        variant="secondary"
                        onClick={() => closeModal()}
                    >
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    </form>

)
}

